import * as React from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { validateUserAddPermission } from "@/lib/api/auth"
import { Button } from "@/components/ui/button"
import {
  Credenza,
  CredenzaBody,
  CredenzaClose,
  CredenzaContent,
  CredenzaDescription,
  CredenzaFooter,
  CredenzaHeader,
  CredenzaTitle,
  CredenzaTrigger,
} from '@/components/ui/credenza'
import BillingUserInfoForm from '@/components/forms/billing-user-info-form'
import { Header } from '@/components/header'
import { Icons } from '@/components/icons'

export const Route = createFileRoute(
  '/_home/user-role-management/billing-user-info/add',
)({
  beforeLoad: async () => {
    validateUserAddPermission()
  },
  component: AddBillingUserInfoPage,
})
export function AddBillingUserInfoPage() {
  const [showAddBillingUserInfoModal, setShowAddBillingUserInfoModal] =
    React.useState<boolean>(false)
  return (
    <>
      <main>
        <Button
          onClick={() =>
            setShowAddBillingUserInfoModal(!showAddBillingUserInfoModal)
          }
        >
          <Icons.add />
          Add Billing User
        </Button>
        <Credenza
          open={showAddBillingUserInfoModal}
          onOpenChange={setShowAddBillingUserInfoModal}
        >
          <CredenzaContent className="flex w-full max-w-[850px] justify-center">
            <CredenzaBody className="mx-auto w-full max-w-6xl px-4">
              <Header
                subroutes={[
                  {
                    route: '/user-role-management/billing-user-info',
                    label: 'Billing User Info',
                  },
                ]}
              >
                Add Billing User
              </Header>
              <BillingUserInfoForm
                onClose={() => setShowAddBillingUserInfoModal(false)}
              />
            </CredenzaBody>
          </CredenzaContent>
        </Credenza>
      </main>
    </>
  )
}
